<div class="AboContainer">
  <!-- Overview card -->
  <mat-card style="background-color: var(--app-surface-variant);" appearance="filled">
    <mat-card-content>
      <h2>Abonnement Überblick</h2>
      <div class="row mg-bt-1rem">
        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Läuft ab</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.endDate | date:'dd.MM.yyyy' }}</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Automatische Verlängerung</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.canceled ? 'Deaktiviert' : 'Aktiviert' }}</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="card row-card">

          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Monatspreis</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.products[0].price / 12 }} €</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Abonnementzeitraum</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>1 Jahr</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>

      <div class="row">
        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Nächstes Rechnungsdatum</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.endDate | date:'dd.MM.yyyy' }}</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Abonnement-ID</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.id }}</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Abonnement Service Plan</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.name }}</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-card class="card row-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <h3>Erstellt am</h3>
            </mat-card-title>

            <mat-card-subtitle>
              <p>{{ subscription.startDate | date:'dd.MM.yyyy' }}</p>
            </mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Used licence -->
  <mat-card style="background-color: var(--app-surface-variant);" appearance="filled">
    <mat-card-header>
      <mat-card-title>
        <h2>Verwendete Lizenzen</h2>
      </mat-card-title>

      <mat-card-subtitle *ngIf="capacity">
        <p> <b>{{ capacity }}</b> - Diese Lizenzen werden für diese Produkte verwendet. </p>
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <mat-card style="box-shadow: none;">
        <div class="table" *ngIf="licensedProducts?.length > 0; else noProducts">
          <div class="row-table border">
            <div><b>ID</b></div>
            <div><b>Name</b></div>
            <div><b>Anzahl der Varianten</b></div>
            <div><b>Anzahl der Versionen</b></div>
            <div><b>Letze Bearbeitungsdatum</b></div>
            <div><b></b></div>
          </div>
          <div *ngFor="let product of licensedProducts" class="row-table">
            <div>
              <p> {{ product.id }}</p>
            </div>
            <div>
              <p> {{ product.name }}</p>
            </div>
            <div>
              <p> {{ product.productVariants?.length || 0 }} </p>
            </div>
            <div>
              <p> {{ getTotalVersionsCount(product) }}</p>
            </div>
            <div>
              <p> {{ product.editDate | date:'dd.MM.yyyy' }}</p>
            </div>
            <div>
              <button class="remove-btn" (click)="handleRemoveProduct(product)" aria-label="Produkt entfernen">
              </button>
            </div>
          </div>
        </div>
        <ng-template #noProducts>
          <div class="empty-message">
            <p>Kein Produkt lizenziert</p>
          </div>
        </ng-template>
      </mat-card>

      <p class="hex-plus-icon">
        <app-hexagon-button-text-icon [text]="'Lizenz dem Produkt zuweisen'" [icon]="'/assets/img/hochladen.png'"
          (click)="openProductsListToggle()">
        </app-hexagon-button-text-icon>
      </p>
      <div style="margin-left: 32px" class="productDropDown" *ngIf="ProductsListToggle">
        <mat-form-field style=" width: 90%;">
          <mat-select placeholder="Produkt" [(ngModel)]="selectedProductId" name="product"
            (selectionChange)="onProductSelectionChange($event)">
            <mat-option *ngIf="filteredProducts.length === 0" disabled>
              Kein Produkt zur Auswahl verfügbar
            </mat-option>
            <mat-option *ngFor="let product of filteredProducts" [value]="product.id">
              {{ product.name }}
            </mat-option>
          </mat-select>
          <button *ngIf="selectedProductId" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearSelection($event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <hexagon [middleColor]="'var(--app-primary)'" [icon]="'plus'" [hover]="selectedProductId ? 'true' : 'false'"
          (click)="selectedProductId ? handleAddProduct() : null" class="add-button"
          [class]="{'disabled-hexagon': !selectedProductId}"></hexagon>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- payment methode card -->
  <mat-card style="background-color: var(--app-surface-variant);" appearance="filled">
    <mat-card-header>
      <mat-card-title>
        <h2>Zahlungsmethode</h2>
      </mat-card-title>

      <mat-card-subtitle>
        <p> Diese Zahlungsmethode wird am <b> {{ subscription.endDate | date:'dd.MMM yyyy' }} </b> zur Verlängerung
          dieses Abonnements verwendet </p>
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <mat-card class="" style="box-shadow: none;">
        <div class="table" *ngIf="paymentData; else noPayment">
          <div class="row-table2 border">
            <div><b>Zahlungsmethode ID</b></div>
            <div><b>Kunden Name</b></div>
            <div><b>Kartentyp</b></div>
            <div><b>Ablaufmonat</b></div>
            <div><b>Ablaufjahr</b></div>
            <div><b>Kartennummern</b></div>
          </div>
          <div class="row-table2" *ngIf="paymentData && paymentData.type === 'card'">
            <div>
              <p> {{ paymentData.id }}</p>
            </div>
            <div>
              <p> {{ paymentData.billing_details.name }}</p>
            </div>
            <div>
              <p> {{ paymentData.card.brand }}</p>
            </div>
            <div>
              <p> {{ paymentData.card.exp_month }}</p>
            </div>
            <div>
              <p> {{ paymentData.card.exp_year }} </p>
            </div>
            <div>
              <p> {{ paymentData.card.last4 }} </p>
            </div>
          </div>

          <div class="row-table2" *ngIf="paymentData && paymentData.type === 'link'">
            <div>
              <p> {{ paymentData.id }}</p>
            </div>
            <div>
              <p> </p>
            </div>
            <div>
              <p> {{ paymentData.type }}</p>
            </div>
            <div>
              <p> </p>
            </div>
            <div>
              <p> </p>
            </div>
            <div>
              <p> </p>
            </div>
          </div>
        </div>
        <ng-template #noPayment>
          <div class="empty-message">
            <p>Keine Zahlungsmethode hinterlegt</p>
          </div>
        </ng-template>
      </mat-card>

      <p class="hex-plus-icon">
        <app-hexagon-button-text-icon [text]="'Zahlungsmethode ändern'" [icon]="'/assets/img/hochladen.png'"
          (click)="managePaymentMethods(null)">
        </app-hexagon-button-text-icon>
      </p>

      <div style="margin-left: 32px" *ngIf="showAlternativePaymentMethods" class="fullWidth nameInfo">
        <mat-form-field>
          <mat-select (selectionChange)="managePaymentMethods($event)" placeholder="Zahlungsart">
            <ng-container *ngFor="let card of allPaymentData">
              <ng-container *ngIf="card.type=='card' && card.id != paymentData.id">
                <mat-option [value]="card.id">{{ card.cardHolder }} / **** **** **** {{ card.card.last4 }}, Läuft ab am
                  {{
                  card.card.exp_month }}/{{ card.card.exp_year }}</mat-option>
              </ng-container>
              <ng-container *ngIf="card.type=='link' && card.id != paymentData.id">
                <mat-option [value]="card.id">{{ card.cardHolder }} / Link, Läuft ab am {{ card.card.exp_month }}/{{
                  card.card.exp_year }}</mat-option>
              </ng-container>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="loading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>